import React from "react";
import { Box } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { adminCatalogActions } from "../../../../redux/slice";
import { useStyles } from "./styles";

export const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  return (
    <Box className={styles.root}>
      <AddButton
        label={t("CATALOGS.ITEMS.ADD_ITEM")}
        onClick={() => dispatch(adminCatalogActions.openAddItemModal())}
      />
    </Box>
  );
};
